module.exports = __webpack_public_path__ + "f181f49daa6642088a4fec0a20a73028.jpg";